import React from "react";
import { motion } from "framer-motion";

export default function Loader({ fullScreen = false }) {
  return (
    <div className={`${fullScreen ? "fixed inset-0 bg-black/95 backdrop-blur-xl z-[9999999]" : "w-full py-24"} flex items-center justify-center`}>
      <div className="relative w-40 h-40">
        {/* Animated Background Glow */}
        <motion.div
           initial={{ opacity: 0, scale: 0.8 }}
           animate={{ opacity: [0.1, 0.3, 0.1], scale: [0.8, 1.2, 0.8] }}
           transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
           className="absolute inset-0 bg-primary/20 rounded-full blur-3xl"
        />

        {/* Precision Box Framing */}
        <motion.svg
          viewBox="0 0 100 100"
          className="w-full h-full relative z-10"
        >
          {/* Main Frame Draw */}
          <motion.path
            d="M 10 10 L 90 10 L 90 90 L 10 90 Z"
            fill="none"
            stroke="rgba(255,255,255,0.2)"
            strokeWidth="0.5"
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{
              pathLength: [0, 1, 1],
              opacity: [0, 1, 0]
            }}
            transition={{
              duration: 2.5,
              repeat: Infinity,
              ease: "easeInOut",
              times: [0, 0.5, 1]
            }}
          />

          {/* Technical Corner Markers */}
          {[
            { x: 10, y: 10 }, { x: 90, y: 10 },
            { x: 90, y: 90 }, { x: 10, y: 90 }
          ].map((point, i) => (
            <motion.circle
              key={i}
              cx={point.x}
              cy={point.y}
              r="1"
              fill="rgba(255,255,255,0.4)"
              initial={{ scale: 0 }}
              animate={{ scale: [0, 1.5, 0] }}
              transition={{
                duration: 2.5,
                repeat: Infinity,
                delay: i * 0.15,
                ease: "easeInOut"
              }}
            />
          ))}

          {/* Industrial H build */}
          <motion.path
            d="M 35 35 L 35 65 M 65 35 L 65 65 M 35 50 L 65 50"
            fill="none"
            stroke="#ffffff"
            strokeWidth="6"
            strokeLinecap="square"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: [0, 1, 0] }}
            transition={{
              duration: 2.5,
              repeat: Infinity,
              ease: "circOut",
              times: [0, 0.6, 1]
            }}
          />
        </motion.svg>

        {/* Technical Subtext Overlay */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: [0, 1, 0] }}
          transition={{ duration: 2.5, repeat: Infinity, times: [0, 0.4, 0.8] }}
          className="absolute -bottom-16 left-0 right-0 text-center"
        >
          <div className="flex flex-col gap-2">
            <span className="text-[11px] font-black tracking-[0.8em] uppercase text-white leading-none">
              H-LINE
            </span>
            <div className="flex items-center justify-center gap-2">
               <span className="w-12 h-[1px] bg-white/10"></span>
               <span className="text-[7px] font-mono uppercase text-gray-500 tracking-[0.3em]">
                 INITIALIZING_CORE
               </span>
               <span className="w-12 h-[1px] bg-white/10"></span>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
